import React, { useState, useEffect } from 'react';
import styles from './TopBanner.module.css';

const ads = [
  {
    title: '表情酱',
    url: 'https://biaoqing.aicosmos.cn/',
    desc: 'AI一键生成创意表情包'
  },
  {
    title: '提示搜',
    url: 'https://prompt.aicosmos.cn/',
    desc: '海量AI图片和AI视频提示词免费分享'
  }
];

const TopBanner = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    // 随机选择一个广告
    const randomAd = ads[Math.floor(Math.random() * ads.length)];
    setAd(randomAd);
  }, []);

  if (!ad) return null;

  return (
    <div className={styles.banner}>
      <a href={ad.url} target="_blank" rel="noopener noreferrer" className={styles.link}>
        <span className={styles.badge}>推荐</span>
        <span className={styles.title}>{ad.title}</span>
        <span className={styles.divider}>|</span>
        <span className={styles.desc}>{ad.desc}</span>
      </a>
    </div>
  );
};

export default TopBanner;
